import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/assets/scss/_reset.scss';
import '@/assets/scss/_fonts.scss';
import '@/assets/scss/_vars.scss';
import '@/assets/scss/_common.scss';

import '@/assets/js/scripts.js'

const app = createApp(App)

app.use(store).use(router).mount('#app')
